<template>
    <header class="top clearfix">
        <router-link tag="h1" class = "logo" :to="{name:'home'}">{{$t("global.title")}}</router-link>
        <a class="logout" v-on:click="logout()">{{ $t("global.exit") }}</a>
        <div class="logout" v-model="UInfo">
          <span class="role">{{UInfo.username+'('+UInfo.role+')'}}</span>
        </div>
        <a class="logout nav">
          <ul v-if="$route.params.app_id && $route.name!=='app'">
            <li v-for="section in appsections" v-if="section.links&&section.links.length>0">{{section.name}}
              <ul><li v-for="link in section.links"><i class="iconfont" :class="link.iconClass"></i> <router-link :to="link.url">{{link.name}}</router-link></li></ul>
            </li>
          </ul>
        </a>
        <a href="https://rockey.feishu.cn/docs/doccn6JwlM1cEdECiiLjznMn546?from=from_copylink" class="logout" target="_blank">
          <i class="el-icon-question"></i>
        </a>
    </header>
</template>

<script>
import store from '../server/store.js'
  export default {
    name:"TopHeader",
    data () {
      return {
        username: '',
        appsections:[],
        UInfo: {},
      }
    },
    methods:{
      switchLang() {
        if(this.$i18n.locale == 'en') {
          this.$i18n.locale = 'zh'
        } else {
          this.$i18n.locale = 'en'
        }
      },
      logout () {
        this.$http.post('/ams/admin/logout', {}).then(res=>{
          document.cookie="token=;Max-Age=-99999999;";
          this.$router.push('/login')
        }).catch((e) => {
          document.cookie="token=;Max-Age=-99999999;";
          this.$router.push('/login')
        })
      },
      getUserInfo(){
        this.UInfo = JSON.parse(localStorage.getItem('userinfo'));
      }
    },
    mounted(){
      this.appsections =  store.fetch('appsections') ? JSON.parse(store.fetch('appsections')) : [];
      this.getUserInfo()
    }
  }
</script>


<style lang="less" scoped>
  @import "@/assets/css/varible.less";
  .top{
    height:@header-height;
    line-height: @header-height;
    padding: 0 20px;
    background: #328cc1;
    color:#fff;
  }
  .logo{
    float: left;
    cursor:pointer;
    font-size: 30px;
  }
  .logout{
    float: right;
    font-size: 18px;
    margin-left: 1.5em;
  }
  .nav{
    font-size: 14px;
    position: relative;

    ul{
      line-height: 30px;
      padding: 10px;
      width: 120px;
      display: none;
      position: absolute;
      top: @header-height;
      right: 0;
      z-index: 998;
      background: #fff;
      color: #333;
      border: 1px solid #ccc;
      border-top: 0;
      li{
        width: 100%;
        padding-left: 20px;
        ul{
          li{
            float: left;
            padding-left: 0;
          }
        }
      }
    }
    &:hover{
      &::after{
        position: absolute;
        bottom: 0;
        right:50px;
        content: '';
        border:8px solid transparent;
        border-bottom: 12px solid @gray;
      }
      ul{
        display: block;
        li{
         ul{
          display: none;
          position: absolute;
          left: -110px;
          top:0;
          z-index: 999;
         }
         &:hover{
          color: @blue;
          ul{
            display: block;
          }
         }
        }
      }
    }
  }

</style>
